import { useState } from 'react';

export const useSearchKeyword = () => {
  const [searchKeyword, setSearchKeyword] = useState<string>('');

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchKeyword(event.target.value);
  };

  const filterItemsBySearchKeyword = <T extends Record<string, unknown>>(
    item: T,
    comparator: (item: T) => string | null | undefined,
  ) => {
    if (!searchKeyword.trim()) {
      return true;
    }

    const keyword = searchKeyword.toLowerCase();

    const value = comparator(item);
    return value?.toLowerCase().includes(keyword) ?? false;
  };

  return {
    searchKeyword,
    onChange,
    filterItemsBySearchKeyword,
  };
};
